<template>
    <HouseKeeperSearchSection v-if="housekeeper_step === 'search'"
      :housekeeper_options="housekeeper_options"
      :housekeeper_controller="housekeeper_controller"
      @houseKeeperSearchClose="onHouseKeeperSearchClose()"
      @houseKeeperSearchConfirm="onHouseKeeperSearchConfirm"
    />

    <HouseKeeperResultsSection v-else-if="housekeeper_step === 'results'"
      :housekeeper_options="housekeeper_options"
      :housekeeper_controller="housekeeper_controller"
      @houseKeeperResultsClose="onHouseKeeperResultsClose()"
    />

    <HouseKeeperOptionsSection v-else
      :housekeeper_options="housekeeper_options"
      @houseKeeperSearch="onHouseKeeperSearch()"
    />
</template>

<script setup>
  import {reactive, ref}           from 'vue';
  import HouseKeeperOptionsSection from './Sections/HouseKeeperOptionsSection.vue';
  import HouseKeeperResultsSection from './Sections/HouseKeeperResultsSection.vue';
  import HouseKeeperSearchSection  from './Sections/HouseKeeperSearchSection.vue';
  import HouseKeeperOptions        from '@/js/Settings/Housekeeper/Entities/HouseKeeperOptions';
  import HouseKeeperController     from '@/js/Settings/Housekeeper/HouseKeeperController';

  const housekeeper_controller = reactive(new HouseKeeperController());
  const housekeeper_options    = reactive(new HouseKeeperOptions());
  const housekeeper_step       = ref('options');

  const onHouseKeeperSearch = async () => {
    housekeeper_options.reset();
    setHouseKeeperStep('search');
  }

  const onHouseKeeperResultsClose = () => {
    setHouseKeeperStep('options');
  }

  const onHouseKeeperSearchClose = () => {
    setHouseKeeperStep('options');
  }

  const onHouseKeeperSearchConfirm = () => {
    setHouseKeeperStep('results');
  }

  const setHouseKeeperStep = (value) => {
    housekeeper_step.value = value;
  }
</script>